<template>
  <component
    :is="block ? 'div' : 'span'"
    class="loading-spinner"
    :class="classes">
    <span class="loading-spinner__spinner">
      <a-icon 
        icon="fa:light:circle-notch"
        :size="size" />
    </span>
  </component>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    size: {
      type: String,
      default: null,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      const result = [];

      if ( this.block ) {
        result.push( "loading-spinner--block" );
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-spinner {
  display: flex;

  &__spinner {
    display: inline-flex;
    animation: spin 0.8s infinite ease-in-out;
  }

  &--block {
    text-align: center;
    color: var( --primary );
  }
}

@keyframes spin {
  from {
    transform: rotate( 0deg );
  }

  to {
    transform: rotate( 360deg )
  }
}
</style>
